export const ROUTE_PATHS = {
    FEE_EXPLAINER_WORKFLOW: '/fee-explainer-workflow',
    RATE_STRING_LOGIC_WORKFLOW: '/fee-explainer-workflow/rate-string-logic-workflow',
    FEATURE_EXPRESSION_WORKFLOW: '/fee-explainer-workflow/fe-workflow',
    FEE_EXPLAINER_CONFIG: '/fee-explainer-config',
    FEE_EXPLAINER_CONFIG_WITH_REGION: '/fee-explainer-config/:region',
    PAYMENT_FEE_TYPE_LAUNCH: '/fee-explainer-config/:region/payment-fee-type-launch',
    CONFIG_REGISTRY: '/config-registry',
} as const;
